<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <!-- <div class="visible-lg"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-videos-channels">
      <div class="row bmw-no-gutter">
        <div class="col-lg-6 bmw-no-gutter">
          <div class="col-lg-3 bmw-no-gutter bmw-lg-circle">
            {{currentChannel?.channelNumber}}
          </div>
          <div class="col-lg-9 bmw-no-gutter">
            <div class="bmw-lg-videos-channels-title">{{currentChannel?.channelName}}</div>
            <div *ngIf="isSubscribed; then thenBlock else elseBlock"></div>
            <ng-template #thenBlock>
              <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22":(APP_SETTINGS.isRollsRoyce === "true")? "#281432":"#1c69d4"}'
                class="bmw-lg-videos-subscribe-btn pointer checked"
                (click)='toggleSubscription(currentChannel.channelNumber)'>
                <div class="col-lg-2 bmw-no-gutter">
                  <i class="material-icons">check_circle</i>
                </div>
                <div class="col-lg-10 bmw-no-gutter" style="font-size: 13px; padding-left: 6px">
                  Subscribed
                </div>
              </div>
            </ng-template>
            <ng-template #elseBlock>
              <div class="bmw-lg-videos-subscribe-btn pointer unchecked"
                (click)='toggleSubscription(currentChannel.channelNumber)'>
                <div class="col-lg-2 bmw-no-gutter">
                  <i class="material-icons">add_circle_outline</i>
                </div>
                <div class="col-lg-10 bmw-no-gutter" style="font-size: 13px; padding-left: 6px">
                  Subscribe
                </div>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="col-lg-6 bmw-no-gutter">
          <form class="input-group" name="findChannels">
            <input [disabled]="" type="text" class="form-control" size=15 style="height:34px;font-size:16px;"
              placeholder="Find Video" name="videoChannel" [(ngModel)]="search4video">
            <div class="input-group-btn">
              <button [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true")? "#281432" : "#1c69d4"}'
                style="color: white" class="btn btn-default" type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="row bmw-no-gutter bmw-lg-video-channel-info-list">
        <div *ngIf='!videosList'>{{serviceError}}</div>
        <div
          *ngFor="let video of videosList?.slice(0,31) | searchFilter: 'videoDisplayId,videoDisplayNumber,videoTitle': search4video |
          paginate: { itemsPerPage: 30, currentPage: page }">
          <div class="pointer" style="float: left; margin-right: 40px;user-select: none">
            <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]'
              [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName,watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
              <div class="bmw-lg-video-home-overlay-text"></div>
            </div>
            <div class="bmw-lg-video-metadata" style="width: 220px; height: 81px">
              <div class="row bmw-no-gutter">
                <div class="col-lg-10 bmw-no-gutter">
                  <div class="row bmw-no-gutter">{{video.videoDisplayNumber}}</div>
                  <div class="row bmw-no-gutter"
                    [innerHTML]='video.videoTitle.length > 50 ? video.videoTitle.substr(0,50)+"..." : video.videoTitle | highlightSearch: searchKey'>
                  </div>
                  <div class="row bmw-no-gutter" style="font-size: 12px; opacity: 0.5">
                    {{video.releaseDate | date: 'yyyy-MM-dd'}} {{video.views}}
                  </div>
                </div>
                <div class="col-lg-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons pointer" style="opacity: 0.7"
                    data-toggle="dropdown">more_vert</i>
                  <ul class="dropdown-menu">
                    <li class="row bmw-no-gutter pointer"
                      (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                      <div class="col-lg-2 bmw-no-gutter bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                      </div>
                      <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                        Add to watchlist
                      </div>
                    </li>
                    <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                      (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                      <div class="col-lg-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">share</i>
                      </div>
                      <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                        Share
                      </div>
                    </li>
                    <li class="divider"></li>
                    <li class="row bmw-no-gutter">
                      <div class="col-lg-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons" style="font-size:20px">close</i>
                      </div>
                      <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                        Cancel
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination-controls (pageChange)="p = $event;pageNumChange($event)"></pagination-controls>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<!-- <div class="visible-md"> -->

<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-videos-channels">
      <div class="row bmw-no-gutter">
        <div class="col-md-6 bmw-no-gutter">
          <div class="col-md-3 bmw-no-gutter bmw-md-cirlce">
            {{currentChannel?.channelNumber}}
          </div>
          <div class="col-md-9 bmw-no-gutter">
            <div class="bmw-lg-videos-channels-title">{{currentChannel?.channelName}}</div>
            <div *ngIf="isSubscribed; then thenBlock else elseBlock"></div>
            <ng-template #thenBlock>
              <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22":"#1c69d4"}'
                class="bmw-lg-videos-subscribe-btn pointer checked"
                (click)='toggleSubscription(currentChannel.channelNumber)'>
                <div class="col-md-2 bmw-no-gutter">
                  <i class="material-icons">check_circle</i>
                </div>
                <div class="col-md-10 bmw-no-gutter" style="font-size: 13px; padding-left: 6px">
                  Subscribed
                </div>
              </div>
            </ng-template>
            <ng-template #elseBlock>
              <div class="bmw-lg-videos-subscribe-btn pointer unchecked"
                (click)='toggleSubscription(currentChannel.channelNumber)'>
                <div class="col-md-2 bmw-no-gutter">
                  <i class="material-icons">add_circle_outline</i>
                </div>
                <div class="col-md-10 bmw-no-gutter" style="font-size: 13px; padding-left: 6px">
                  Subscribe
                </div>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="col-md-6 bmw-no-gutter">
          <form class="input-group" name="findChannels">
            <input [disabled]="" type="text" class="form-control" size=15 style="height:34px;font-size:16px;"
              placeholder="Find Video" name="videoChannel" [(ngModel)]="search4video">
            <div class="input-group-btn">
              <button style="color: white"
                [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true")? "#281432" :"#1c69d4"}'
                class="btn btn-default" type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="row bmw-no-gutter bmw-lg-video-channel-info-list">
        <div *ngIf='!videosList'>{{serviceError}}</div>
        <div
          *ngFor="let video of videosList?.slice(0,31) | searchFilter: 'videoDisplayId,videoDisplayNumber,videoTitle': search4video |
          paginate: { itemsPerPage: 30, currentPage: page }">
          <div class="pointer" style="float: left; margin-right: 12px;user-select: none">
            <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]'
              [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName,watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
              <div class="bmw-lg-video-home-overlay-text"></div>
            </div>
            <div class="bmw-lg-video-metadata" style="width: 220px; height: 80px">
              <div class="row bmw-no-gutter">
                <div class="col-md-10 bmw-no-gutter">
                  <div class="row bmw-no-gutter">{{video.videoDisplayNumber}}</div>
                  <div class="row bmw-no-gutter"
                    [innerHTML]='video.videoTitle.length > 50 ? video.videoTitle.substr(0,50)+"..." : video.videoTitle | highlightSearch: searchKey'>
                  </div>
                  <div class="row bmw-no-gutter" style="font-size: 12px; opacity: 0.5">
                    {{video.releaseDate | date: 'yyyy-MM-dd'}} {{video.views}}
                  </div>
                </div>
                <div class="col-md-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons pointer" style="opacity: 0.7"
                    data-toggle="dropdown">more_vert</i>
                  <ul class="dropdown-menu">
                    <li class="row bmw-no-gutter pointer"
                      (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                      <div class="col-md-2 bmw-no-gutter bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                      </div>
                      <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                        Add to watchlist
                      </div>
                    </li>
                    <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                      (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                      <div class="col-md-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">share</i>
                      </div>
                      <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                        Share
                      </div>
                    </li>
                    <li class="divider"></li>
                    <li class="row bmw-no-gutter">
                      <div class="col-md-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons" style="font-size:20px">close</i>
                      </div>
                      <div class="col-md-9 bmw-no-gutter" style="margin-left: 10px">
                        Cancel
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-md-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm"> -->
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm-video-channel-info">
      <div class="row bmw-no-gutter" style="margin-top: 7px">
        <form class="input-group" name="findChannels">
          <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Video"
            name="videoChannel" [(ngModel)]="search4video">
          <div class="input-group-btn">
            <button [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22":(APP_SETTINGS.isRollsRoyce === "true")? "#281432" :"#1c69d4"}'
              style="color: white; height: 34px" class="btn btn-default" type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
      <div class="row bmw-no-gutter" style="margin-bottom: 30px">
        <div class="col-sm-3 bmw-no-gutter bmw-sm-circle">
          {{currentChannel?.channelNumber}}
        </div>
        <div class="col-sm-9">
          <div class="bmw-sm-videos-channels-title">{{currentChannel?.channelName}}</div>
          <div *ngIf="isSubscribed; then thenBlock else elseBlock"></div>
          <ng-template #thenBlock>
            <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22":"#1c69d4"}'
              class="bmw-sm-videos-subscribe-btn pointer checked"
              (click)='toggleSubscription(currentChannel.channelNumber)'>
              <div class="col-sm-2 bmw-no-gutter">
                <i class="material-icons">check_circle</i>
              </div>
              <div class="col-sm-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                Subscribed
              </div>
            </div>
          </ng-template>
          <ng-template #elseBlock>
            <div class="row bmw-no-gutter bmw-sm-videos-subscribe-btn pointer unchecked"
              (click)='toggleSubscription(currentChannel.channelNumber)'>
              <div class="col-sm-2 bmw-no-gutter">
                <i class="material-icons">add_circle_outline</i>
              </div>
              <div class="col-sm-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                Subscribe
              </div>
            </div>
          </ng-template>
        </div>
      </div>
      <div class="row bmw-no-gutter" style="margin-top:15px">
        <div
          *ngFor="let video of videosList?.slice(0,24) | searchFilter: 'videoDisplayId,videoDisplayNumber,videoTitle': search4video |
          paginate: { itemsPerPage: 30, currentPage: page }">
          <div class="pointer" style="float: left; margin-right: 17px;user-select: none">
            <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]'
              [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName,watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
              <div class="bmw-lg-video-home-overlay-text"></div>
            </div>
            <div class="bmw-lg-video-metadata" style="width: 220px; height: 80px">
              <div class="row bmw-no-gutter">
                <div class="col-sm-10 bmw-no-gutter">
                  <div class="row bmw-no-gutter">{{video.videoDisplayNumber}}</div>
                  <div class="row bmw-no-gutter"
                    [innerHTML]='video.videoTitle.length > 50 ? video.videoTitle.substr(0,50)+"..." : video.videoTitle | highlightSearch: searchKey'>
                  </div>
                  <div class="row bmw-no-gutter" style="font-size: 12px; opacity: 0.5">
                    {{video.releaseDate | date: 'yyyy-MM-dd'}} {{video.views}}
                  </div>
                </div>
                <div class="col-sm-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons pointer" style="opacity: 0.7"
                    data-toggle="dropdown">more_vert</i>
                  <ul class="dropdown-menu">
                    <li class="row bmw-no-gutter pointer"
                      (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                      <div class="col-sm-2 bmw-no-gutter bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                      </div>
                      <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                        Add to watchlist
                      </div>
                    </li>
                    <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                      (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                      <div class="col-sm-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">share</i>
                      </div>
                      <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                        Share
                      </div>
                    </li>
                    <li class="divider"></li>
                    <li class="row bmw-no-gutter">
                      <div class="col-sm-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons" style="font-size:20px">close</i>
                      </div>
                      <div class="col-sm-9 bmw-no-gutter" style="margin-left: 10px">
                        Cancel
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-sm-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs"> -->
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-video-channel-info">
      <div class="row bmw-no-gutter" style="margin-bottom: 30px">
        <div class="col-xs-3 bmw-no-gutter bmw-xs-circle">
          {{currentChannel?.channelNumber}}
        </div>
        <div class="col-xs-9">
          <div class="bmw-xs-videos-channels-title">{{currentChannel?.channelName}}</div>
          <div *ngIf="isSubscribed; then thenBlock else elseBlock"></div>
          <ng-template #thenBlock>
            <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22":"#1c69d4"}'
              class="bmw-xs-videos-subscribe-btn pointer checked"
              (click)='toggleSubscription(currentChannel.channelNumber)'>
              <div class="col-xs-2 bmw-no-gutter">
                <i class="material-icons">check_circle</i>
              </div>
              <div class="col-xs-10 bmw-no-gutter" style="font-size: 13px; padding-left: 6px">
                Subscribed
              </div>
            </div>
          </ng-template>
          <ng-template #elseBlock>
            <div class="row bmw-no-gutter bmw-xs-videos-subscribe-btn pointer unchecked"
              (click)='toggleSubscription(currentChannel.channelNumber)'>
              <div class="col-xs-2 bmw-no-gutter">
                <i class="material-icons">add_circle_outline</i>
              </div>
              <div class="col-xs-10 bmw-no-gutter" style="font-size: 13px; padding-left: 6px">
                Subscribe
              </div>
            </div>
          </ng-template>
        </div>
      </div>
      <form class="input-group" name="findChannels">
        <input type="text" class="form-control" size=15 style="height:40px;font-size:16px;" placeholder="Find Video"
          name="videoChannel" [(ngModel)]="search4video">
        <div class="input-group-btn">
          <button [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22":(APP_SETTINGS.isRollsRoyce === "true")? "#281432" :"#1c69d4"}'
            style="color: white; height: 40px" class="btn btn-default" type="submit">
            <i class="glyphicon glyphicon-search"></i>
          </button>
        </div>
      </form>
      <div class="row bmw-no-gutter"
        *ngFor="let video of videosList?.slice(0,10) | searchFilter: 'videoDisplayId,videoDisplayNumber,videoTitle': search4video |
        paginate: { itemsPerPage: 30, currentPage: page }"
        style="margin-top:15px">
        <div class="col-xs-6 bmw-no-gutter">
          <a [routerLink]='["/playback"]'
            [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName,watchlist: false}'>
            <img src="{{videoThumbnail}}" />
            <!-- <video height="84px" width="150px" [src]='video?.videoFileName'></video> -->
          </a>
        </div>
        <div class="col-xs-5 bmw-no-gutter" style="padding-left:3px">
          <div class="row bmw-no-gutter" [innerHTML]='video.videoDisplayNumber | highlightSearch: searchKey'></div>
          <div class="row bmw-no-gutter"
            [innerHTML]='video.videoTitle.length > 19 ? video.videoTitle.substr(0,20)+"..." : video.videoTitle | highlightSearch: searchKey'>
          </div>
          <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:3px">
            <div class="col-xs-6 bmw-no-gutter"
              [innerHTML]='video.releaseDate | date: dateFormat | highlightSearch: searchKey'></div>
            <div class="col-xs-6 bmw-no-gutter bmw-align-text-right" [innerHTML]='video.views'></div>
          </div>
        </div>
        <div class="col-xs-1 bmw-no-gutter">
          <div class="dropdown dropdown-pull-right btn-group">
            <i class="material-icons pointer" style="opacity: 0.7" data-toggle="dropdown">more_vert</i>
            <ul class="dropdown-menu">
              <li class="row bmw-no-gutter pointer" (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                <div class="col-xs-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                </div>
                <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                  Add to watchlist
                </div>
              </li>
              <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                <div class="col-xs-2 bmw-no-gutter  bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px">share</i>
                </div>
                <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                  Share
                </div>
              </li>
              <li class="divider"></li>
              <li class="row bmw-no-gutter">
                <div class="col-xs-2 bmw-no-gutter  bmw-align-text-right">
                  <i class="material-icons" style="font-size:20px">close</i>
                </div>
                <div class="col-xs-9 bmw-no-gutter" style="margin-left: 10px">
                  Cancel
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-xs-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>